export const ThinkProperty = () => {
  return (
    <div className="flex flex-col gap-8">
      Think property custom info content{' '}
    </div>
  );
};
